import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';

import LoanTableRecords from '../LoansTableRecords';

const DisbursedLoans = () => (
  <LoanTableRecords tabStatus="APPROVED" defaultUrl={AdminRouteName.disbursedLoansRoute} toggleStorageId="disbursed-loan-table-col" hasNameAndImage permissionName="can-view-disbursed-credit-request" />
);
export default DisbursedLoans;
